import React from "react";
import cx from "classnames";
import _ from "lodash";
import Guesser from "../../../../assets/images/tot/GUESSER.png";
import MvpImage from "../../../../assets/images/tot/mvp.png";
import { connect } from "react-redux";

const Person = (props) => {
  const status = _.get(props, "gameReducer.roomObj.game_state.status");
  const {
    activeGuesser,
    color = "",
    imageClassName = "",
    mvp = false,
    players_with_max_score = []
  } = props;
  let profileImg = "";
  let activeUserName = "";
  if (mvp) {
    profileImg = _.get(players_with_max_score[0], "profile_image", "");
    activeUserName = _.get(players_with_max_score[0], "display_name", "");
  } else {
    profileImg = activeGuesser ? _.get(activeGuesser, "profile_image") : "";
    activeUserName = activeGuesser ? _.get(activeGuesser, "display_name") : "";
  }
  return (
    <>
      <div className="tot-person">
        <img className={cx("person-img", imageClassName)} src={profileImg} />
      </div>
      <div className="tot-person-bg">
        <p className="guesser-text">
          {mvp ? (
            <img src={MvpImage} className="mvpimg" alt="Guesser" />
          ) : (
            <img src={Guesser} alt="Guesser" />
          )}
        </p>
        <p
          className={cx("person-name", `text${color ? `-${color}` : ""}`, {
            PreGuess: status === "PreGuess",
            Guessing: status === "Guessing",
            ResultRound: status === "ResultRound"
          })}
        >
          {activeUserName}
        </p>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Person);
